import { makeStyles, } from '@material-ui/core/styles';
import { colors } from '../../../constants/colors/Colors';
export const useStyles = makeStyles((theme) => ({
    monthlyBillHeading: {
        color: colors.titleColor,
        fontSize: 26,
        fontWeight: '500',
        letterSpacing: '-0.001em',
        marginTop: 30,
    },
    billAmount: {
        color: colors.titleColor,
        fontSize: 30,
        fontWeight: '500',
        letterSpacing: '-0.001em',
        marginTop: 28,
    },
    cardsBtnsRow: {
        display: 'inline-flex',
        "@media (max-width: 490px)": {
            display: 'block',
        },
    },
    notSelectedBtn: {
        display: 'flex',
        alignItems: 'center',
        height: 42,
        padding: 10,
        border: `1px solid #D2D7DC`,
        borderRadius: 6,
        justifyContent: 'center',
        cursor: 'pointer',
        marginRight: 30,
        "@media (max-width: 490px)": {
            width: '100%',
            marginTop: 20,
        },
    },
    selectedBtn: {
        display: 'flex',
        alignItems: 'center',
        height: 42,
        padding: 10,
        cursor: 'pointer',
        background: 'linear-gradient(#824ED2, #B07DFF)',
        borderRadius: 6,
        justifyContent: 'center',
        marginRight: 30,
        "@media (max-width: 490px)": {
            width: '100%',
            marginTop: 20,
        },
    },
    notSelectedBtnText: {
        color: '#94999E',
        fontSize: 16,
        fontWeight: '600',
    },
    selectedBtnText: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '400',
    },
    creditsHeadingAndInfoIconRow: {
        display: 'inline-flex',
        marginTop: 4,
    },
    creditsHeading: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 26,
        fontWeight: '500',
        marginRight: 4,
    },
    label: {
        marginTop: -5,
        marginBottom: 10,
    },
    input: {
        width: '100%',
        borderRadius: 8,
        border: '1px solid #D4DDE4',
        boxSizing: 'border-box',
        background: '#F4F6F8',
        height: 49,
        paddingLeft: 14,
        paddingRight: 14,
        marginBottom: 20,
    },
    placeholder: {
        color: '#94999E',
    },
    saveAndCancelBtnRow: {
        marginTop: 10,
        display: 'inline-flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        width: '100%',
    },
    cancelBtn: {
        borderRadius: 6,
        border: '1px solid #94999E',
        boxSizing: 'border-box',
        background: '#FFFFFF',
        height:42,
        width:99,
        color:'#5B6773',
        cursor:'pointer',
    },
    saveBtn:{
        borderRadius:6,
        background: 'linear-gradient(#824ED2, #B07DFF)',
        height:42,
        width:151,
        color:'#FFFFFF',
        border:'none',
        marginLeft:12,
        cursor:'pointer',
    },
}));

